import axios from 'axios';
import { getEcho } from '../lib/echo';

const api = axios.create({
  baseURL: '/santiye', // Production alt dizin; dev'te Vite proxy ile /api yine çalışır
  timeout: 30000,
  // Token tabanli auth (Bearer) kullaniliyor; session cookie gondermeye gerek yok.
  // withCredentials:true, onceki testlerden kalan gecersiz session cookie'lerinin
  // Sanctum'un web guard'ini etkinlestirip token'i devre disi birakmasina yol acabiliyor.
  withCredentials: false,
  headers: { Accept: 'application/json' },
});

// Request interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Laravel Echo/Reverb socket id'sini ilet ki backend toOthers() calissin.
  const echo = getEcho();
  const socketId = echo?.socketId();
  if (socketId) {
    config.headers['X-Socket-Id'] = socketId;
  }
  return config;
});

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Login sayfasindaki normal auth hatalarinda (ornegin yanlis sifre)
      // sayfayi yeniden yuklemeyip formun hata mesajini gostermesine izin ver.
      // Canli ortamda uygulama /santiye alt dizininde calistigindan
      // BASE_URL ile login yolunu olusturuyoruz.
      if (!window.location.pathname.endsWith('/login')) {
        window.location.assign(`${import.meta.env.BASE_URL}login`);
      }
    }
    if (error.response?.status === 429) {
      window.dispatchEvent(
        new CustomEvent('api-error', { detail: { message: 'Çok fazla istek. Lütfen biraz bekleyin.' } })
      );
    }
    return Promise.reject(error);
  }
);

export default api;
